import { clearCookies, getRefreshToken, getToken, getMobileToken } from "@/utils/tokenCheck";
import { projectAccess, userLogOut, clearNotification } from "@/views/Login/api-client";
import Vue from "vue";
import Vuex from "vuex";
const qs = require("qs");

Vue.use(Vuex);

const state = () => ({
	userData: null,
	adminID: null,
});

const getters = {
	getUserData: (state) => state.userData,
};

const actions = {
	async getUserData({ commit }) {
		try {
			const response = await projectAccess();
			commit("setUserData", response.data.data);
		} catch (error) {
			console.log(error);
		}
	},
	LogOut(state) {
		userLogOut(
			qs.stringify({
				client_id: "vue-test-app",
				refresh_token: getRefreshToken(),
			}),
			{
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
				Authorization: `Bearer ${getToken()}`,
			}
		)
			.then(async (response) => {
				if(getMobileToken()) await clearNotification({token: getMobileToken()});
				localStorage.clear();
				clearCookies();
				state.commit("clearData");
				location.replace(
					// `http://localhost:8082/login`
					`https://app.hire3x.com/login`
				);
				return response;
			})
			.catch(async (error) => {
				console.error(error);
				if(getMobileToken()) await clearNotification({token: getMobileToken()});
				localStorage.clear();
				clearCookies();
				state.commit("clearData");
				location.replace(
					// `http://localhost:8082/login`
					`https://app.hire3x.com/login`
				);
				return error;
			});
	},
};

const mutations = {
	clearData(state) {
		state.userData = null;
		state.adminID = null;
	},
	setUserData(state, payload) {
		state.userData = payload;
	},
	setAdminID(state, payload) {
		state.adminID = payload;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
